import api from 'api';
import {
  addUserBrandLocationSuccess, updateUserBrandLocationSuccess,
} from 'actions/user-brands';

export const LOCATION_ASYNC_ACTION_START = 'LOCATION_ASYNC_ACTION_START';
export const LOCATION_ASYNC_ACTION_ERROR = 'LOCATION_ASYNC_ACTION_ERROR';
export const LOCATION_ASYNC_UPDATE_SUCCESS = 'LOCATION_ASYNC_UPDATE_SUCCESS';
export const LOCATION_UPDATE_SUCCESS = 'LOCATION_UPDATE_SUCCESS';
export const LOCATION_RESET_STATE = 'LOCATION_RESET_STATE';

function locationAsyncStart() {
  return {
    type: LOCATION_ASYNC_ACTION_START,
  };
}

function locationAsyncUpdateSuccess(data) {
  return {
    type: LOCATION_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

function locationAsyncError(error) {
  return {
    type: LOCATION_ASYNC_ACTION_ERROR,
    error,
  };
}

export function resetLocationState() {
  return {
    type: LOCATION_RESET_STATE,
  };
}

export function updateLocation(data) {
  return {
    type: LOCATION_UPDATE_SUCCESS,
    data,
  };
}

export function createLocationAsync(location) {
  return (dispatch, getState) => {
    dispatch(locationAsyncStart());
    return api.request('location', 'post', location)
    .then((data) => {
      dispatch(locationAsyncUpdateSuccess(data));
      dispatch(addUserBrandLocationSuccess(data));
    })
    .catch((err) => {
      dispatch(locationAsyncError('Unable to create location'));
      throw (err);
    });
  };
}

export function updateLocationAsync(location) {
  return (dispatch, getState) => {
    dispatch(locationAsyncStart());
    return api.request('location', 'put', location)
    .then((data) => {
      dispatch(locationAsyncUpdateSuccess(data));
      dispatch(updateUserBrandLocationSuccess(data));
    })
    .catch((err) => {
      dispatch(locationAsyncError('Unable to update location'));
      throw (err);
    });
  };
}

export function getLocationAsync(id) {
  return (dispatch, getState) => {
    dispatch(locationAsyncStart());
    return api.request(`location?locationId=${ id }`, 'get')
    .then((data) => {
      dispatch(locationAsyncUpdateSuccess(data));
      dispatch(updateUserBrandLocationSuccess(data));
    })
    .catch((err) => {
      dispatch(locationAsyncError('Unable to get location'));
      throw (err);
    });
  };
}
